import { ColumnInfo } from "../../../../models/column-info";
import { UnitWish } from "../../../../models/unit-wish-list";
import { unitBaseTypeEnum } from "../../../../unit-base-type-enum";
import { InitialProps } from "../../Common/BuildingInitialPropertiesDialog/init-props";
import { alignment } from "../../models/alignment.enum";
import { Column, UnitAmount } from "../../models/column";
import { Part, RefinedParts } from "../../models/part";
import { bodiesEnum } from "./bodies.enum";
import { subtypeEnum, variantEnum } from "./column-definition";
import { columnType } from "./column-type.enum";
import { crownType } from "./crown-type.enum";
import { headType } from "./head-type.enum";
import { defaultHead } from "./head-types.model";
import { middleType } from "./middle-type.enum";
import { partTypeEnum } from "./part-type.enum";
import { plinthType } from "./plinth-type.enum";
import { segmentType } from "./segment-type";

export type CorridorColumn = Column<columnType | headType, segmentType, subtypeEnum, variantEnum>;
export type CorridorPart = Part<CorridorColumn, partTypeEnum>;
export type CorridorRefinedParts = RefinedParts<CorridorColumn, partTypeEnum>;

export const defaultUnitWishList: UnitWish[] = [
    {
        type: unitBaseTypeEnum.C_XS,
        uiName: 'XS',
        percentage: 20,
    },
    {
        type: unitBaseTypeEnum.C_S,
        uiName: 'S',
        percentage: 20,
    },
    {
        type: unitBaseTypeEnum.C_M,
        uiName: 'M',
        percentage: 20,
    },
    {
        type: unitBaseTypeEnum.C_L,
        percentage: 20,
        uiName: 'L',
    },
    {
        type: unitBaseTypeEnum.C_XL,
        uiName: 'XL',
        percentage: 20,
    },
]

export type PropsCorridor = {
    buildingWidth: number;
    buildingLength: number;
    buildingHeight: number;
    plinthType: plinthType;
    middleType: middleType;
    crownType: crownType;
    plinthFloors: number;
    customPlinthHeight: number;
    customPlinthWidth: number;
    crownFloors: number;
    moosPlazaType: columnType;
    moosPlazaAlignment: alignment;
    moosPlazaPosition: bodiesEnum;
    moosPlazaBays: number;
    selectedHeadType: headType;
    unitWishList: { type: unitBaseTypeEnum, percentage: number }[];
    totalPercentageC: number;
    amount_C_XS_Columns: number;
    amount_C_M_Columns: number;
    amount_C_S_Columns: number;
    amount_C_L_Columns: number;
    amount_C_XL_Columns: number;
    parts: CorridorPart[];
    partsRefined: CorridorRefinedParts[];
    info: ColumnInfo;
    totalAmountOfAllUnits: UnitAmount[];
}


export const getDefaultPropsCorridor = (initProps: InitialProps): PropsCorridor => {
    let unitWishList = initProps.unitWishList.length > 0 ? initProps.unitWishList : defaultUnitWishList;
    return {
        buildingWidth: 21,
        buildingLength: 51,
        buildingHeight: 15.625,
        plinthType: plinthType.C,
        middleType: middleType.C,
        crownType: crownType.C,
        plinthFloors: 1,
        customPlinthHeight: 0,
        customPlinthWidth: 0,
        crownFloors: 1,
        moosPlazaType: columnType.V_P3C_C_L,
        moosPlazaAlignment: alignment.left,
        moosPlazaPosition: bodiesEnum.A,
        moosPlazaBays: 3,
        selectedHeadType: defaultHead,
        unitWishList,
        totalPercentageC: 100,
        amount_C_XS_Columns: 0,
        amount_C_M_Columns: 0,
        amount_C_S_Columns: 0,
        amount_C_L_Columns: 0,
        amount_C_XL_Columns: 0,
        parts: [],
        partsRefined: [],
        info: {
            totalGFA: 0,
            totalUFA: 0,
        },
        totalAmountOfAllUnits: [],
    }
}
